export default ({ notifications = [] }) => {
  const discount = notifications.filter(n => n.typeDescriptor === 'discount')[0];
  if (discount) {
    return discount.value;
  }
  return null;
};



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/helpers/getDiscountLabel.js